import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import {
  CommonService,
  DocumentService,
  IndexedDBService,
} from '@via/services';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';

import {
  DocumentApi,
  DocumentMetadata,
  DocumentParams,
} from '../../models/document';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'via-document-viewer',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    ChipModule,
    FooterComponent,
  ],
  templateUrl: './document-viewer.component.html',
  styleUrl: './document-viewer.component.scss',
})
export class DocumentViewerComponent {
  htmlContent: SafeHtml = '';
  documentParams?: DocumentParams;
  documentMetadata?: DocumentMetadata;
  stream: DocumentApi = DocumentApi.Core;
  uniqueId = '';
  documentName = '';
  isTemporary = false;
  showErrorMessage = false;
  document?: { htmlContent: string; file: File };

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private commonService: CommonService,
    private indexedDBService: IndexedDBService,
    private documentService: DocumentService
  ) {}

  async ngOnInit() {
    ({
      stream: this.stream = DocumentApi.Core,
      uniqueId: this.uniqueId = '',
      documentName: this.documentName = 'Document.docx',
    } = this.route.snapshot.params);
    ({ temporary: this.isTemporary = false } = this.route.snapshot.queryParams);

    const { fileName, fileExt, fileSize, fileType, ...restProperties } =
      this.route.snapshot.queryParams;
    this.documentParams = restProperties;
    this.documentMetadata = {
      fileName,
      fileExt,
      fileSize,
      fileType,
    };
    let htmlContent = '';
    if (this.isTemporary) {
      this.document =
        (await this.indexedDBService.fetchDocument(this.uniqueId)) || undefined;
      if (!this.document) {
        this.showErrorMessage = true;
      }
      htmlContent = this.document?.htmlContent || '';
    } else if (this.documentMetadata) {
      this.documentMetadata['documentType'] =
        this.documentParams['documentType'];
      htmlContent = await this.documentService.convertDocumentToHtml(
        this.stream,
        {
          uniqueId: this.uniqueId,
          documentMetadata: this.documentMetadata,
          caseNumber: this.documentParams['caseNumber'],
        }
      );
    }
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  downloadDocument() {
    if (this.showErrorMessage) {
      this.commonService.showToast(
        'Warn',
        'Looks like the document you are looking for is not available!'
      );
      return;
    }
    if (this.isTemporary && !this.showErrorMessage) {
      this.documentService.createAndDownloadWordFile(
        this.document?.file,
        this.documentName
      );
      return;
    }
    const payload = {
      caseNumber: this.documentParams?.['caseNumber'] || '',
      documentType: this.documentParams?.['documentType'] || '',
    };
    if (this.documentMetadata) {
      this.documentService.download(
        this.stream,
        this.uniqueId,
        this.documentMetadata,
        payload
      );
    }
  }
}
